import React from "react";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { Calendar, Check } from "@phosphor-icons/react";
import { MAINTENANCE_CALENDAR, PHOTOS } from "../lib/data";

export default function MaintenancePage() {
    return (
        <div data-testid="maintenance-page">
            <PageHero
                eyebrow="Annual Maintenance Program"
                title="A property in great condition, all twelve months."
                sub="Our season-long care program keeps your turf, beds, and ornamentals healthy from first thaw to last leaf — with one trusted crew and one predictable plan."
                image={PHOTOS.frontYardArborvitae}
            />

            <section className="px-4 sm:px-8 pb-12">
                <div className="max-w-5xl mx-auto">
                    <div className="relative">
                        <div className="hidden md:block absolute left-[27px] top-2 bottom-2 w-px bg-brand-border" />
                        <div className="space-y-10">
                            {MAINTENANCE_CALENDAR.map((m, i) => (
                                <article key={m.month} data-testid={`maintenance-${m.month}`} className="relative grid md:grid-cols-12 gap-6 md:gap-10">
                                    <div className="md:col-span-3 flex md:block items-center gap-4">
                                        <div className="relative h-14 w-14 rounded-full bg-brand-primary text-white flex items-center justify-center ring-8 ring-brand-bg z-10">
                                            <Calendar size={22} weight="duotone" />
                                        </div>
                                        <div className="md:mt-4">
                                            <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold">Visit {String(i + 1).padStart(2, "0")}</p>
                                            <p className="font-serif text-2xl text-brand-primary font-medium mt-1">{m.month}</p>
                                        </div>
                                    </div>
                                    <div className="md:col-span-9">
                                        <h3 className="font-serif text-2xl sm:text-3xl text-brand-primary font-medium leading-tight">{m.title}</h3>
                                        <ul className="mt-4 space-y-2.5">
                                            {m.items.map((x) => (
                                                <li key={x} className="flex items-start gap-3 text-brand-textMuted">
                                                    <Check size={16} weight="bold" className="mt-1 text-brand-accent shrink-0" />
                                                    <span>{x}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="px-4 sm:px-8 py-20 bg-brand-surfaceAlt">
                <div className="max-w-5xl mx-auto text-center">
                    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-4">Why a contract</p>
                    <h2 className="font-serif text-4xl sm:text-5xl text-brand-primary leading-[1.1] font-medium tracking-tight">
                        One plan, one crew, one number to call.
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-brand-textMuted leading-relaxed max-w-2xl mx-auto">
                        A maintenance contract gives your property the discipline of a planned schedule — and gives you the peace of mind of knowing every visit is already on the calendar.
                    </p>
                </div>
            </section>

            <CTABanner
                eyebrow="Get a custom plan"
                title="Request your maintenance proposal."
                sub="Pricing is based on property size, plant material, and scope. Estimates are free and detailed."
                primaryLabel="Request Maintenance Quote"
            />
        </div>
    );
}
